/* Catomi — боковая корзина: поведение.
   Лежит отдельным файлом, а не внутри секции: раньше эти 28 КБ ехали в разметке
   КАЖДОЙ страницы сайта и не кэшировались никогда. Теперь браузер скачивает их
   один раз и дальше берёт из своего кэша.
   Настройки приходят из секции в теге <script type="application/json"
   data-catomi-cart-config> — правятся в редакторе темы, файл менять не нужно. */
(function () {
    var CFG = (function () {
        var el = document.querySelector('[data-catomi-cart-config]');
        if (!el) { return {}; }
        try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
    })();

    var ANIM = CFG.btnAnim;
    var SWITCH_ON = CFG.switchOn;
    var SHOW_DOT = CFG.showDot;
    var IMG_PX = CFG.imgPx || 220;

    var drawer = null;
    var products = {};      /* handle -> данные товара, тянем один раз */
    var busy = false;

    function ready(fn) {
        if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); }
        else { fn(); }
    }

    function money(cents) {
        if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
            try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) {}
        }
        return '';
    }

    /* ---------- переключатель варианта в строке корзины ---------- */

    function handleOf(row) {
        var a = row.querySelector('.previewCartItem-name');
        if (!a) { return null; }
        var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
        return m ? m[1] : null;
    }
    function variantIdOf(row) {
        var el = row.querySelector('[data-cart-remove-id]');
        return el ? String(el.getAttribute('data-cart-remove-id')) : null;
    }
    function lineKeyOf(row) {
        var el = row.querySelector('[data-line]');
        return el ? el.getAttribute('data-line') : null;
    }

    /* Корень витрины: на английской это «/», на немецкой «/de/».
       Без него запрос уходил на язык магазина по умолчанию, и названия цветов
       в плашках приходили английскими даже на переведённой витрине. */
    function root() {
        var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
        return r || '/';
    }

    function getProduct(handle) {
        if (products[handle]) { return Promise.resolve(products[handle]); }
        return fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { products[handle] = p; return p; });
    }

    function qtyOf(row) {
        var qtyEl = row.querySelector('[data-edit-cart-quantity]');
        var qty = qtyEl ? (parseInt(qtyEl.getAttribute('data-edit-cart-quantity'), 10) || 0) : 0;
        if (!qty) {
            var inp = row.querySelector('input[name="updates[]"], .previewCartItem-quantity input, input[type="number"]');
            qty = inp ? (parseInt(inp.value, 10) || 1) : 1;
        }
        return qty;
    }
    function variantById(product, id) {
        if (!product || !product.variants) { return null; }
        for (var i = 0; i < product.variants.length; i++) {
            if (String(product.variants[i].id) === String(id)) { return product.variants[i]; }
        }
        return null;
    }

    /* Мгновенная перерисовка строки под новый вариант — БЕЗ ожидания сети.
       Меняем только то, что человек видит: фото, подпись варианта, ссылки, alt.
       ЦЕНУ НЕ ТРОГАЕМ. /products/<handle>.js отдаёт цены в валюте магазина (EUR),
       а в корзине показана валюта покупателя (замерено: 652,00 zł при shop_currency
       EUR). Пересчитать её на клиенте нельзя, поэтому мгновенный путь включается
       только когда цена варианта не меняется — тогда менять в цене просто нечего. */
    function paintRowVariant(row, product, v) {
        var url = product.url + '?variant=' + v.id;
        var name = product.title + (v.title && v.title !== 'Default Title' ? ' - ' + v.title : '');
        var prev = variantById(product, variantIdOf(row));
        var prevTitle = prev ? prev.title : null;

        var links = row.querySelectorAll('a.previewCartItem-image, a.previewCartItem-name');
        for (var i = 0; i < links.length; i++) { links[i].setAttribute('href', url); }

        var img = row.querySelector('.previewCartItem-image img');
        if (img && v.featured_image && v.featured_image.src) {
            var base = v.featured_image.src.split('?')[0];
            img.removeAttribute('sizes');
            img.setAttribute('alt', name);
            img.setAttribute('src', base + '?width=' + IMG_PX);
            img.setAttribute('srcset', base + '?width=' + IMG_PX + ' 1x, ' + base + '?width=' + (IMG_PX * 2) + ' 2x');
            img.dataset.catomiHq = '1';
        }

        var label = row.querySelector('.previewCartItem-variant');
        if (label) { label.textContent = ' ' + v.title + ' '; }

        /* Подсказки на кнопках НЕ пишем по-английски. Тема отдаёт их уже
           переведёнными («Remove …» / «Entfernen …» / «Usuń …»), и раньше мы
           затирали перевод английским текстом: на немецкой витрине после первой
           же смены цвета подсказка ломалась. Теперь внутри готовой строки
           заменяем только название варианта, а сам глагол — тот, что дала тема. */
        function swapVariantInTitle(el) {
            if (!el || !prevTitle) { return; }
            var t = el.getAttribute('title');
            if (!t) { return; }
            /* Меняем ПОСЛЕДНЕЕ вхождение: название варианта стоит в конце строки.
               Если менять все, у товара вроде «Beige Bed - Beige» поедет и само
               название товара, а не только цвет. */
            var i = t.lastIndexOf(prevTitle);
            if (i === -1) { return; }
            el.setAttribute('title', t.slice(0, i) + v.title + t.slice(i + prevTitle.length));
        }
        swapVariantInTitle(row.querySelector('[data-cart-remove]'));
        var ed = row.querySelector('.previewCartItem-edit');
        swapVariantInTitle(ed);
        if (ed) { ed.setAttribute('data-edit-cart-url', url + '&view=ajax_edit_cart'); }
        stampVariant(row, v.id);
    }

    /* Адреса строки в корзине. id варианта знаем сразу, ключ строки — только
       от сервера, поэтому проставляем в два приёма. Пока ключ не обновлён,
       кнопка «удалить» указывает на строку, которой уже нет, — но она и не
       нажимается: между двумя вызовами проходит один тик. */
    function stampVariant(row, id) {
        var a = row.querySelectorAll('[data-cart-remove-id]');
        for (var i = 0; i < a.length; i++) { a[i].setAttribute('data-cart-remove-id', id); }
        var b = row.querySelectorAll('[data-edit-cart-id]');
        for (var j = 0; j < b.length; j++) { b[j].setAttribute('data-edit-cart-id', id); }
    }
    function stampLine(row, cart, id) {
        for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].id) !== String(id)) { continue; }
            var line = cart.items[i].key, index = i + 1;
            var els = row.querySelectorAll('[data-line]');
            for (var j = 0; j < els.length; j++) {
                els[j].setAttribute('data-line', line);
                els[j].setAttribute('data-index', index);
            }
            return true;
        }
        return false;
    }

    /* Смена варианта: сначала кладём новый, потом убираем старую строку.
       Именно в этом порядке — если новый вариант вдруг разобран, старый
       останется в корзине, а не пропадёт. */
    function swap(row, newId) {
        if (busy) { return; }
        var key = lineKeyOf(row);
        if (!key) { return; }
        var oldId = variantIdOf(row);
        var qty = qtyOf(row);
        var handle = handleOf(row);

        busy = true;
        var sw = row.querySelector('[data-catomi-sw]');

        var product = handle ? products[handle] : null;
        var nv = variantById(product, newId);
        var ov = variantById(product, oldId);
        /* Цена та же — на экране сразу всё верное, сеть отработает незаметно.
           Цена другая — картинку, название и плашку всё равно рисуем сразу:
           человек должен видеть отклик на нажатие, а не замерший экран.
           А вот цену подставить нечем: /products/<handle>.js отдаёт её в валюте
           магазина, на экране — валюта покупателя. Пока сервер считает, на месте
           цены стоит серая полоска: врать старым числом нельзя, по нему
           оформляется заказ. */
        var instant = !!(nv && ov && nv.price === ov.price && nv.compare_at_price === ov.compare_at_price);

        if (nv && product) {
            paintRowVariant(row, product, nv);
            markChip(row, newId);
            if (!instant) { markRepricing(row); }
        } else if (sw) {
            sw.classList.add('is-busy');
        }

        fetch(root() + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(newId), quantity: qty }] })
        })
        .then(function (r) {
            if (!r.ok) { throw new Error('add failed'); }
            var updates = {};
            updates[key] = 0;
            return fetch(root() + 'cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
            }).then(function (r2) {
                if (!r2.ok) { throw new Error('update failed'); }
                return r2.json();
            });
        })
        /* Сверяемся с настоящей корзиной: новый вариант обязан там быть,
           старой строки — не быть. Если что-то пошло не так, перезагружаем
           страницу, чтобы человек видел правду, а не старую картинку.
           Корзину берём из ответа update.js: отдельный запрос за ней не нужен,
           а на телефоне каждый лишний круг в сеть — это видимая пауза. */
        .then(function (cart) {
            var added = false, stale = false, sameQty = false;
            for (var i = 0; i < cart.items.length; i++) {
                if (String(cart.items[i].id) === String(newId)) {
                    added = true;
                    /* Количество могло не сойтись: если нового цвета на складе
                       меньше, Shopify молча кладёт сколько есть. Тогда сумма на
                       экране станет враньём — и быстрый путь запрещён. */
                    sameQty = cart.items[i].quantity === qty;
                }
                if (cart.items[i].key === key) { stale = true; }
            }
            if (!added || stale) { window.location.reload(); return; }
            if (instant && !sameQty) { return refreshDrawer(cart); }

            /* Быстрый путь: на экране уже всё верно. Осталось проставить новый
               ключ строки (по нему работают «удалить» и счётчик) и сказать теме,
               что корзина изменилась. Разметку не перебираем — именно её замена
               и давала провал интерфейса и секунду занятого главного потока. */
            if (instant) {
                if (!stampLine(row, cart, newId)) { return refreshDrawer(cart); }
                syncCartMeta(cart);
                return;
            }
            return refreshDrawer(cart);
        })
        /* Не получилось — не оставляем человека с картинкой, которой нет в корзине:
           спрашиваем у сервера правду и перерисовываем ящик целиком. */
        .catch(function () {
            if (sw) { sw.classList.remove('is-busy'); }
            return refreshDrawer();
        })

        .then(function () { busy = false; });
    }

    /* То, что при полной перерисовке делала тема, а при быстром пути делаем мы:
       счётчик в шапке, полоска бесплатной доставки и событие для остальных
       скриптов. Сумма и цены не трогаются — быстрый путь включается только
       когда они не менялись. */
    function syncCartMeta(cart) {
        var n = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < n.length; i++) { n[i].textContent = cart.item_count; }
        var w = document.querySelectorAll('[data-free-shipping-wrapper]');
        for (var j = 0; j < w.length; j++) { w[j].dispatchEvent(new Event('change', { bubbles: true })); }
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
    }

    /* Цена и итоги на время пересчёта притухают и мигают. Число остаётся
       настоящим: в корзине пока лежит прежняя строка. Снимать класс не надо —
       разметку целиком заменит refreshDrawer. */
    function markRepricing(row) {
        var box = document.getElementById('halo-cart-sidebar');
        var els = row.querySelectorAll('.previewCartItem-price');
        for (var i = 0; i < els.length; i++) { els[i].classList.add('catomi-price-wait'); }
        if (!box) { return; }
        var t = box.querySelectorAll('.previewCartTotals-value');
        for (var j = 0; j < t.length; j++) { t[j].classList.add('catomi-price-wait'); }
    }

    /* Подсветка плашек без пересборки: меняем состояние у двух кнопок,
       а не выбрасываем и не строим ряд заново — иначе он мигает. */
    function markChip(row, newId) {
        var wrap = row.querySelector('[data-catomi-sw]');
        if (!wrap) { return; }
        var chips = wrap.querySelectorAll('.catomi-cartsw__chip');
        for (var i = 0; i < chips.length; i++) {
            var on = String(chips[i].getAttribute('data-vid')) === String(newId);
            chips[i].classList.toggle('is-on', on);
            chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
    }

    /* Перерисовка ящика темой. Корзину передаём готовую, если она уже есть на руках —
       тогда сети остаётся один запрос за разметкой вместо двух. Ждём события
       cart-update (тема шлёт его, когда разметка уже вставлена), а не таймера
       вслепую: иначе плашки вариантов рисуются по старому содержимому. */
    function refreshDrawer(cart) {
        return new Promise(function (res) {
            var upd = window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
            if (!upd) { window.location.reload(); res(); return; }

            var done = false;
            function finish() {
                if (done) { return; }
                done = true;
                document.removeEventListener('cart-update', finish);
                clearTimeout(guard);
                setTimeout(function () { paint(); res(); }, 30);
            }
            var guard = setTimeout(finish, 3000);
            document.addEventListener('cart-update', finish);

            if (cart) {
                upd(cart);
            } else if (window.Shopify && window.Shopify.getCart) {
                window.Shopify.getCart(function (c) { upd(c); });
            } else {
                finish();
            }
        });
    }

    function buildSwitch(row, product, currentId) {
        var wrap = document.createElement('div');
        wrap.className = 'catomi-cartsw';
        wrap.setAttribute('data-catomi-sw', '');

        product.variants.forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'catomi-cartsw__chip' + (String(v.id) === currentId ? ' is-on' : '');
            b.setAttribute('data-vid', v.id);
            if (!v.available) { b.disabled = true; }
            b.setAttribute('aria-pressed', String(v.id) === currentId ? 'true' : 'false');

            if (SHOW_DOT && v.featured_image && v.featured_image.src) {
                var dot = document.createElement('span');
                dot.className = 'catomi-cartsw__dot';
                dot.style.backgroundImage = 'url(' + v.featured_image.src + ')';
                b.appendChild(dot);
            }
            var t = document.createElement('span');
            t.textContent = v.title;
            b.appendChild(t);

            /* Обработчик вешаем на ВСЕ доступные плашки, а не только на неактивные:
               после мгновенной смены ряд не пересобирается, меняется только подсветка,
               и вчерашняя «текущая» плашка обязана остаться нажимаемой. Повторное
               нажатие по уже выбранной отсекаем здесь же. */
            if (v.available) {
                b.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (String(variantIdOf(row)) === String(v.id)) { return; }
                    swap(row, v.id);
                });
            }
            wrap.appendChild(b);
        });
        return wrap;
    }

    /* Тема отдаёт превью шириной 110px и в такой же srcset. На плотном экране
       и при растянутом по высоте фото его приходится увеличивать — отсюда мыло.
       Забираем оригинал с CDN и просим нужную ширину под 1x и 2x. */
    function sharpen(row) {
        var img = row.querySelector('.previewCartItem-image img');
        if (!img || img.dataset.catomiHq === '1') { return; }
        var src = img.getAttribute('src') || '';
        var m = src.match(/^(.*?)(?:_\d+x\d*)?(\.(?:jpg|jpeg|png|webp))(\?.*)?$/i);
        if (!m) { return; }
        var base = m[1] + m[2];
        var qs = m[3] || '';
        var join = qs ? '&' : '?';
        img.dataset.catomiHq = '1';
        img.removeAttribute('sizes');
        img.setAttribute('src', base + qs + join + 'width=' + IMG_PX);
        img.setAttribute('srcset',
            base + qs + join + 'width=' + IMG_PX + ' 1x, ' +
            base + qs + join + 'width=' + (IMG_PX * 2) + ' 2x');
    }

    function paintRow(row) {
        sharpen(row);
        if (!SWITCH_ON || row.dataset.catomiSw === '1') { return; }
        var handle = handleOf(row);
        var current = variantIdOf(row);
        var opts = row.querySelector('.previewCartItem-options');
        /* Плашек не будет: стиль держит место под них и прячет подпись, возвращаем её */
        function plain() { if (opts) { opts.classList.add('catomi-sw-off'); } }
        if (!handle || !current) { plain(); return; }
        row.dataset.catomiSw = '1';

        getProduct(handle).then(function (p) {
            if (!p || !p.variants || p.variants.length < 2) { plain(); return; }
            if (row.querySelector('[data-catomi-sw]')) { return; }
            var sw = buildSwitch(row, p, current);
            if (opts) {
                opts.classList.add('has-catomi-sw');
                opts.parentNode.insertBefore(sw, opts.nextSibling);
            } else {
                var head = row.querySelector('.previewCartItem-header');
                if (head) { head.parentNode.insertBefore(sw, head.nextSibling); }
            }
        }).catch(plain);
    }

    /* Свой квадратик согласия. Настоящий input тема прячет и слушает его change,
       поэтому мы не подменяем поведение, а только рисуем: клик по нашему
       квадратику нажимает настоящий чекбокс, а он уже включает кнопку Checkout. */
    function paintTerms() {
        var box = drawer.querySelector('.previewCartCheckbox');
        if (!box || box.dataset.catomiCb === '1') { return; }
        var input = box.querySelector('.global-checkbox--input');
        if (!input) { return; }
        box.dataset.catomiCb = '1';

        var el = document.createElement('span');
        el.className = 'catomi-cb';
        el.setAttribute('aria-hidden', 'true');
        box.insertBefore(el, box.firstChild);
        box.classList.add('has-catomi-cb');

        function sync() { box.classList.toggle('is-checked', input.checked); }
        el.addEventListener('click', function (e) { e.preventDefault(); input.click(); });
        input.addEventListener('change', sync);
        sync();
    }

    var UPS_TITLE = CFG.upsTitle;
    var UPS_BTN = CFG.upsBtn;
    var UPS_MAX = CFG.upsMax;
    var UPS_HIDE_IN_CART = CFG.upsHideInCart;
    var UPS_PLACE = CFG.upsPlace;
    var UPS_HIDE_EMPTY = CFG.upsHideEmpty;

    function upsData() {
        var tag = document.querySelector('[data-catomi-ups-data]');
        if (!tag) { return []; }
        try { return JSON.parse(tag.textContent) || []; } catch (e) { return []; }
    }

    function idsInCart() {
        var out = {};
        var rows = drawer.querySelectorAll('.previewCartItem');
        for (var i = 0; i < rows.length; i++) {
            var v = variantIdOf(rows[i]);
            if (v) { out[v] = true; }
        }
        return out;
    }

    /* товар уже в корзине — любым цветом: Walnut в корзине прячет и Natural */
    function upsInCart(p, вКорзине) {
        var ids = p.vids && p.vids.length ? p.vids : [p.id];
        for (var i = 0; i < ids.length; i++) { if (вКорзине[String(ids[i])]) { return true; } }
        return false;
    }

    function upsAdd(card, id) {
        card.classList.add('is-busy');
        fetch(root() + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return refreshDrawer(); })
        .catch(function () { card.classList.remove('is-busy'); });
    }

    function upsCard(p) {
        var card = document.createElement('div');
        card.className = 'catomi-ups__card';

        if (p.img) {
            var a = document.createElement('a');
            a.className = 'catomi-ups__pic';
            a.href = p.url;
            var img = document.createElement('img');
            img.src = p.img;
            img.alt = p.title;
            img.loading = 'lazy';
            img.width = 320;
            img.height = 320;
            a.appendChild(img);
            card.appendChild(a);
        }

        var body = document.createElement('div');
        body.className = 'catomi-ups__body';

        var name = document.createElement('a');
        name.className = 'catomi-ups__name';
        name.href = p.url;
        name.textContent = p.title;
        body.appendChild(name);

        var price = document.createElement('div');
        price.className = 'catomi-ups__price';
        var now = document.createElement('span');
        now.className = 'money';
        now.innerHTML = p.price;
        price.appendChild(now);
        if (p.compare) {
            var was = document.createElement('s');
            was.className = 'catomi-ups__was money';
            was.innerHTML = p.compare;
            price.appendChild(was);
        }
        if (p.off > 0) {
            var off = document.createElement('span');
            off.className = 'catomi-ups__off';
            off.textContent = '-' + p.off + '%';
            price.appendChild(off);
        }
        body.appendChild(price);
        card.appendChild(body);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'catomi-ups__add';
        btn.textContent = UPS_BTN;
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            upsAdd(card, p.id);
        });
        card.appendChild(btn);

        return card;
    }

    /* лента листается родной прокруткой: пальцем это работает само,
       кнопки просто сдвигают её на карточку и заворачивают по кругу */
    function стрелка(куда, лента) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'catomi-ups__arrow catomi-ups__arrow--' + (куда === 'назад' ? 'prev' : 'next');
        b.setAttribute('aria-label', куда === 'назад' ? 'Previous' : 'Next');
        b.innerHTML = куда === 'назад'
            ? '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>'
            : '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>';
        b.addEventListener('click', function (e) {
            e.preventDefault();
            var шаг = лента.clientWidth;
            var предел = лента.scrollWidth - шаг - 2;
            if (куда === 'назад') {
                лента.scrollLeft = лента.scrollLeft <= 2 ? предел + 2 : лента.scrollLeft - шаг;
            } else {
                лента.scrollLeft = лента.scrollLeft >= предел ? 0 : лента.scrollLeft + шаг;
            }
        });
        return b;
    }

    var upsSign = null;

    function paintUpsell() {
        var wrap = drawer.querySelector('.previewCart-wrapper');
        if (!wrap) { return; }

        /* В пустой корзине предлагать нечего. Пустоту узнаём двумя признаками: тема ставит
           .previewCart-emptyBody, но только ПОСЛЕ своей перерисовки — в первой, серверной
           разметке его нет, и блок успевал построиться и мелькнуть. Второй признак —
           в ящике нет ни одной строки товара. */
        var пустаяКорзина = drawer.querySelector('.previewCart-emptyBody') || !drawer.querySelector('.previewCartItem');
        if (UPS_HIDE_EMPTY && пустаяКорзина) {
            var пустойБлок = wrap.querySelector('.catomi-ups');
            if (пустойБлок) { пустойБлок.parentNode.removeChild(пустойБлок); }
            upsSign = 'пусто';
            return;
        }

        var список = upsData();
        if (!список.length) { return; }

        var вКорзине = idsInCart();
        /* Подпись считаем только по товарам ЭТОГО блока, а не по всей корзине.
           Иначе смена цвета основного товара меняла подпись и блок пересобирался
           впустую — с миганием картинок, хотя показывает он ровно то же самое. */
        var подпись = список
            .map(function (p) { return upsInCart(p, вКорзине) ? p.id : ''; })
            .join(',');
        var старый = wrap.querySelector('.catomi-ups');
        /* перерисовываем только когда состав корзины изменился — иначе наблюдатель
           за перерисовкой корзины и мы будем будить друг друга без конца */
        if (старый && подпись === upsSign) { return; }
        upsSign = подпись;
        if (старый) { старый.parentNode.removeChild(старый); }

        var есть = UPS_HIDE_IN_CART ? вКорзине : {};
        var годные = [];
        for (var i = 0; i < список.length && годные.length < UPS_MAX; i++) {
            var p = список[i];
            if (!p.available) { continue; }
            if (UPS_HIDE_IN_CART && upsInCart(p, есть)) { continue; }
            годные.push(p);
        }
        if (!годные.length) { return; }

        var блок = document.createElement('div');
        блок.className = 'catomi-ups';

        var шапка = document.createElement('div');
        шапка.className = 'catomi-ups__head';
        var h = document.createElement('span');
        h.className = 'catomi-ups__title';
        h.textContent = UPS_TITLE || '';
        шапка.appendChild(h);

        var лента = document.createElement('div');
        лента.className = 'catomi-ups__list';
        годные.forEach(function (p) { лента.appendChild(upsCard(p)); });

        var нав = document.createElement('div');
        нав.className = 'catomi-ups__nav';
        нав.appendChild(стрелка('назад', лента));
        нав.appendChild(стрелка('вперёд', лента));
        if (годные.length < 2) { нав.setAttribute('hidden', ''); }
        шапка.appendChild(нав);

        блок.appendChild(шапка);
        блок.appendChild(лента);

        var список_товаров = wrap.querySelector('.previewCartList');
        if (UPS_PLACE === 'list' && список_товаров) {
            список_товаров.parentNode.insertBefore(блок, список_товаров.nextSibling);
        } else {
            var итоги = wrap.querySelector('.previewCartInfo');
            if (итоги) { wrap.insertBefore(блок, итоги); } else { wrap.appendChild(блок); }
        }
    }

    /* Верх панели: количество и полоса бесплатной доставки.
       Тема обновляет их последними: количество после разметки корзины, полосу отдельным
       запросом, текст ещё через 400 мс. Панель выезжала с «0 items», затем полоса сдвигала
       всё на 20px. Рисуем сразу, как только тема получила корзину: это раньше выезда панели. */
    function paintTop(cart) {
        if (!cart) { return; }
        var i;
        var counts = document.querySelectorAll('[data-cart-count]');
        for (i = 0; i < counts.length; i++) { counts[i].textContent = cart.item_count; }
        var s = window.cartStrings;
        var texts = document.querySelectorAll('[data-cart-text]');
        for (i = 0; s && i < texts.length; i++) { texts[i].textContent = cart.item_count === 1 ? s.item : s.items; }

        var w = drawer && drawer.querySelector('[data-free-shipping-wrapper]');
        if (!w || !w.calculateProgress || !w.progressBar) { return; }
        if (!w.catomiNow) {
            var later = w.setProgressWidthAndText;
            w.setProgressWidthAndText = function (bar, text, cls) {
                this.resetProgressClass(cls);
                this.progressMeter.style.width = bar + '%';
                this.messageElement.innerHTML = text;
                later.call(this, bar, text, cls);   /* тема повторит то же и пересчитает валюту */
            };
            w.catomiNow = true;
        }
        w.calculateProgress(cart);
    }

    function hookGetCart() {
        var S = window.Shopify;
        if (!S || !S.getCart || S.getCart.catomiTop) { return; }
        var orig = S.getCart;
        S.getCart = function (cb) {
            return orig.call(S, function (cart) {
                paintTop(cart);
                if (typeof cb === 'function') { cb(cart); }
                else if (S.onCartUpdate) { S.onCartUpdate(cart); }
            });
        };
        S.getCart.catomiTop = true;
    }

    function paint() {
        if (!drawer) { return; }
        drawer.setAttribute('data-btn-anim', ANIM);
        paintTerms();
        var rows = drawer.querySelectorAll('.previewCartItem');
        for (var i = 0; i < rows.length; i++) { paintRow(rows[i]); }
        paintUpsell();
    }

    ready(function () {
        var tries = 0;
        var t = setInterval(function () {
            drawer = document.getElementById('halo-cart-sidebar');
            if (drawer) {
                clearInterval(t);
                hookGetCart();
                paint();
                /* корзина перерисовывается темой при каждом изменении — следим */
                var list = drawer.querySelector('.previewCart-wrapper') || drawer;
                new MutationObserver(function () { paint(); }).observe(list, { childList: true, subtree: true });
            } else if (++tries > 60) { clearInterval(t); }
        }, 120);
    });
})();

/* Catomi — окно политики.
   Ссылки на политики в плашке cookie и в подписке открывают текст в окне — так же,
   как «Terms & Conditions» в корзине, — а не уводят с текущей страницы. Текст берём
   со страницы самой политики при первом нажатии и дальше держим в памяти. Если
   загрузить не вышло, ведём на страницу политики, как было раньше.
   Нажатие с Ctrl / Cmd / Shift по-прежнему открывает страницу в новой вкладке. */
(function () {
    /* ссылки Shopify о cookie: сама ссылка зовётся shopify-pc__banner__body-policy-link,
       а окна плашки и настроек — shopify-pc__…; ловим любую ссылку на политику внутри них */
    var SEL = 'a[data-catomi-policy], a[id^="shopify-pc__"][href*="/policies/"], [id^="shopify-pc__"] a[href*="/policies/"], .shopify-pc__banner a[href*="/policies/"], .shopify-pc__prefs a[href*="/policies/"]';
    var cache = {};
    var req = 0;
    var lastFocus = null;

    function parts() {
        var pop = document.getElementById('catomi-policy-popup');
        if (!pop) { return null; }
        return {
            pop: pop,
            back: document.querySelector('.catomi-pp-backdrop'),
            title: pop.querySelector('.halo-popup-title'),
            body: pop.querySelector('[data-catomi-pp-body]'),
            close: pop.querySelector('.halo-popup-close')
        };
    }

    function load(url) {
        var key = url.split('#')[0];
        if (cache[key]) { return Promise.resolve(cache[key]); }
        return fetch(key, { credentials: 'same-origin' }).then(function (r) {
            if (!r.ok) { throw new Error(String(r.status)); }
            return r.text();
        }).then(function (t) {
            var doc = new DOMParser().parseFromString(t, 'text/html');
            var b = doc.querySelector('.shopify-policy__body') ||
                    doc.querySelector('.policy-container .rte') ||
                    doc.querySelector('.policy-container');
            if (!b) { throw new Error('no policy body'); }
            var h = doc.querySelector('.shopify-policy__title h1') || b.querySelector('h1') || doc.querySelector('main h1');
            var d = { title: h ? h.textContent.trim() : '' };
            /* заголовок уже стоит в шапке окна — второй раз в тексте он не нужен */
            var own = b.querySelector('h1');
            if (own) { own.parentNode.removeChild(own); }
            d.html = b.innerHTML;
            cache[key] = d;
            return d;
        });
    }

    function open(url, label) {
        var p = parts();
        if (!p) { return false; }
        /* ставим окно последним в body: плашка cookie тоже на верхнем слое,
           и при равном слое сверху оказывается тот, кто ниже в разметке */
        if (p.back) { document.body.appendChild(p.back); }
        document.body.appendChild(p.pop);
        if (label) { p.title.textContent = label; }
        p.body.innerHTML = '';
        p.pop.setAttribute('aria-busy', 'true');
        document.body.classList.add('catomi-policy-show');
        if (p.close && p.close.focus) { p.close.focus({ preventScroll: true }); }
        var mine = ++req;
        load(url).then(function (d) {
            if (mine !== req) { return; }
            if (d.title) { p.title.textContent = d.title; }
            p.body.innerHTML = d.html;
            p.body.scrollTop = 0;
            p.pop.removeAttribute('aria-busy');
        }).catch(function () {
            if (mine !== req) { return; }
            window.location.href = url;
        });
        return true;
    }

    function hide() {
        if (!document.body.classList.contains('catomi-policy-show')) { return; }
        document.body.classList.remove('catomi-policy-show');
        req++;
        if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); }
        lastFocus = null;
    }

    /* ловим на всплытии вниз (capture), чтобы опередить плашку cookie:
       у неё свои обработчики на тех же ссылках */
    document.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
        var t = e.target;
        if (!t || !t.closest) { return; }
        if (t.closest('[data-catomi-pp-close]')) { e.preventDefault(); hide(); return; }
        /* «Terms & Conditions» у галочки в корзинах: у темы там старая копия текста, берём живую политику */
        var tc = t.closest('[data-term-condition]');
        if (tc && document.getElementById('catomi-policy-popup')) {
            var tr = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            e.preventDefault();
            e.stopPropagation();
            lastFocus = tc;
            open(new URL(tr + 'policies/terms-of-service', window.location.href).href, '');
            return;
        }
        var a = t.closest(SEL);
        if (!a) { return; }
        var link = a.getAttribute('href') ? a : a.querySelector('a[href]');
        if (!link) { return; }
        var url;
        try { url = new URL(link.getAttribute('href'), window.location.href); } catch (err) { return; }
        if (url.origin !== window.location.origin || url.pathname.indexOf('/policies/') < 0) { return; }
        /* ссылка без языка на французской витрине открыла бы английскую политику */
        var lr = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (lr !== '/' && url.pathname.indexOf(lr) !== 0) { url.pathname = lr.replace(/\/$/, '') + url.pathname; }
        if (!document.getElementById('catomi-policy-popup')) { return; }
        e.preventDefault();
        e.stopPropagation();
        lastFocus = link;
        open(url.href, (link.textContent || '').trim());
    }, true);

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') { return; }
        var body = document.body.classList;
        if (body.contains('catomi-policy-show')) {
            e.stopPropagation();
            hide();
        } else if (body.contains('cart-sidebar-show') && !body.contains('has-warning') &&
                   !body.contains('edit-cart-show') && !body.contains('term-condition-show') &&
                   !body.contains('quickshop-popup-show')) {
            // те же условия, что у закрытия боковой корзины по фону (theme.js)
            body.remove('cart-sidebar-show');
        }
    }, true);
})();
